import { createApiSlice } from "@common/common-slice/commonSlice";

import {
  CRUD_GAP_ANALYSIS,
  GET_GAP_ANALYSIS
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "getGapAnalysis",
    method: "get",
    url: GET_GAP_ANALYSIS,
    stateKey: "data",
  },
  {
    name: "deleteGapAnalysis",
    method: "delete",
    url: CRUD_GAP_ANALYSIS,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    additionalData: [],
    details: [],
    genData: [],
  },
  reducers: {
  },
  // extraReducers: {
  //   // Example of custom extra reducer
  //   someCustomAction: (state, action) => {
  //     // Custom reducer logic
  //   },
  // },
};

const { slice, thunks, actions } = createApiSlice(
  "gapAnalysis",
  apiConfig,
  customReducers
);
const gapAnalysisSlice = slice;

export default gapAnalysisSlice.reducer;

export const actionsExports = actions;

export const {
  getGapAnalysis,
  deleteGapAnalysis,
} = thunks;

export const { rowSelect } =
  actionsExports;
